import { defineMessages } from 'react-intl';

export const metricSelectionMessages: {
	// Intro section (4 metrics)
	introTotalNodes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	introTotalUsers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	introTotalRelationships: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	introTotalApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Graph shape section (6 metrics)
	shapePagesCreated: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shapeLoomsRecorded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shapeWorkItemUpdates: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shapeQueriesPerDay: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shapeTeamsConnected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	shapeCommentsAdded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Graph connectivity section (8 metrics)
	connectivityJiraCodeLinks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivitySmartLinkPastes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivityArtifactsPerIssue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivityGoalLinks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivityActiveContributors: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivityEntitiesTouched: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivityUniqueCollaborators: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectivityMeetingsLinked: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// Intro section (4 metrics)
	introTotalNodes: {
		id: 'twg-microsite.metricSelection.introTotalNodes',
		defaultMessage: '{value} items',
		description: 'Total number of nodes in the graph',
	},
	introTotalUsers: {
		id: 'twg-microsite.metricSelection.introTotalUsers',
		defaultMessage: '{value} people',
		description: 'Total number of users in the graph',
	},
	introTotalRelationships: {
		id: 'twg-microsite.metricSelection.introTotalRelationships',
		defaultMessage: '{value} relationships',
		description: 'Total number of relationships in the graph',
	},
	introTotalApps: {
		id: 'twg-microsite.metricSelection.introTotalApps',
		defaultMessage: '{value} different apps',
		description: 'Number of different apps connected to the graph',
	},

	// Graph shape section (6 metrics)
	shapePagesCreated: {
		id: 'twg-microsite.metricSelection.shapePagesCreated',
		defaultMessage: 'pages created this month',
		description: 'Number of pages created in the last 30 days',
	},
	shapeLoomsRecorded: {
		id: 'twg-microsite.metricSelection.shapeLoomsRecorded',
		defaultMessage: 'Looms recorded this month, saving you {minutesSaved} minutes in meetings',
		description: 'Number of Looms recorded in the last 30 days with estimated minutes saved',
	},
	shapeWorkItemUpdates: {
		id: 'twg-microsite.metricSelection.shapeWorkItemUpdates',
		defaultMessage: 'work items progressed this week',
		description: 'Number of work items moved forward in the last 7 days',
	},
	shapeQueriesPerDay: {
		id: 'twg-microsite.metricSelection.shapeQueriesPerDay',
		defaultMessage: 'queries served yesterday',
		description: 'Average number of fetch queries served per day',
	},
	shapeTeamsConnected: {
		id: 'twg-microsite.metricSelection.shapeTeamsConnected',
		defaultMessage: 'teams connected in your graph',
		description: 'Number of teams connected in the graph',
	},
	shapeCommentsAdded: {
		id: 'twg-microsite.metricSelection.shapeCommentsAdded',
		defaultMessage: 'comments left on pages, work items, projects and goals',
		description: 'Number of comments added across the graph',
	},

	// Graph connectivity section (8 metrics)
	connectivityJiraCodeLinks: {
		id: 'twg-microsite.metricSelection.connectivityJiraCodeLinks',
		defaultMessage: 'issues linked to code changes',
		description: 'Number of Jira issues linked to code changes',
	},
	connectivitySmartLinkPastes: {
		id: 'twg-microsite.metricSelection.connectivitySmartLinkPastes',
		defaultMessage: 'links pasted to GitHub, Figma, and Google Docs this month',
		description: 'Number of smart link pastes in the last 30 days',
	},
	connectivityArtifactsPerIssue: {
		id: 'twg-microsite.metricSelection.connectivityArtifactsPerIssue',
		defaultMessage: 'number of artifacts connected to every work item on average',
		description: 'Average number of artifacts per work item',
	},
	connectivityGoalLinks: {
		id: 'twg-microsite.metricSelection.connectivityGoalLinks',
		defaultMessage: 'Atlassian goals that have traceable work streams',
		description: 'Number of goals linked to work items',
	},
	connectivityActiveContributors: {
		id: 'twg-microsite.metricSelection.connectivityActiveContributors',
		defaultMessage: 'people actively contributing to your graph this month',
		description: 'Number of active contributors in the last 30 days',
	},
	connectivityEntitiesTouched: {
		id: 'twg-microsite.metricSelection.connectivityEntitiesTouched',
		defaultMessage: 'artifacts in the graph affected by your work in the last month',
		description: 'Number of entities the user has touched in the last 30 days',
	},
	connectivityUniqueCollaborators: {
		id: 'twg-microsite.metricSelection.connectivityUniqueCollaborators',
		defaultMessage: 'people who you have worked with across {teams} teams this month',
		description: 'Number of unique collaborators and teams in the last 30 days',
	},
	connectivityMeetingsLinked: {
		id: 'twg-microsite.metricSelection.connectivityMeetingsLinked',
		defaultMessage: 'your meetings that have linked recordings and notes',
		description: 'Percentage of meetings with linked recordings and notes',
	},
});

export type MetricSelectionMessageKey = keyof typeof metricSelectionMessages;
